/* SIZESOFTX
=========================================================================================
* Descripción: Catálogo de Almacenes Exhibidores
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/04/2026 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 15/05/2026 | Antigravity AI                   | Refactorización UX y fix de payload
* ---------------------------------------------------------------------------------------
*/

import TextField from "../../ui/TextField";
import { Fragment, useEffect } from "react";
import { Box, Card, CardContent, Divider } from "@mui/material";

import SizeSoftXLayout from "../../../components/leyout/SizeSoftXLayout.jsx";
import SizeSoftXTableCatalogos from "../../../components/leyout/SizeSoftXTableCatalogos.jsx";
import MnuAlmacenesExhibidoresActions from "./MnuAlmacenesExhibidoresActions.jsx";
import SizeSoftXModal from "../../../components/leyout/SizeSoftXModal.jsx";
import { useAlmacenesExhibidores } from "../../../context/Catalogos/AlmacenesExhibidoresContext";
import { useLayout } from "../../../context/System/LayoutContext";
import { useSesion } from "../../../context/System/SesionContext";
import { useFormTabLock } from "../../../hooks/useFormTabLock";

export default function FrmAlmacenesExhibidores() {
    const { isLocked: isFormLocked } = useFormTabLock('almacenes_exhibidores', {
        title: 'Almacenes Exhibidores',
        onLockDetected: (info) => {
            console.warn(`El formulario de ${info?.title || 'Almacenes Exhibidores'} ya está abierto en otra pestaña`);
        }
    });

    const {
        almacenesExhibidoresSeleccionado,
        almacenesExhibidoresPayLoad,
        listaAlmacenesExhibidores,
        statusEnableFields,
        statusOpenModalEliminarAlmacenesExhibidores,
        setStatusOpenModalEliminarAlmacenesExhibidores,
        handleClickEliminarAlmacenesExhibidores,
        handleClickRegresarMainDashboard,
        handleChangeDataAlmacenesExhibidoresPayload,
        handleObtenerAlmacenesExhibidoresList,
        handleAlmacenesExhibidoresSeleccionadoFromModal,
    } = useAlmacenesExhibidores();

    const { handleChangeTitle, handleChangeClavePaginaActual, handleOpenAlert } = useLayout();
    const { getPermisoBoton } = useSesion();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [listaAlmacenesExhibidores]);

    useEffect(() => {
        if (isFormLocked) {
            handleOpenAlert(
                "El formulario de Almacenes Exhibidores ya está abierto en otra pestaña del navegador.\n\nPor favor, cierre la otra ventana o pestaña para continuar.",
                "error"
            );
            setTimeout(() => {
                if (handleClickRegresarMainDashboard) handleClickRegresarMainDashboard();
            }, 900);
        }
    }, [isFormLocked, handleClickRegresarMainDashboard, handleOpenAlert]);

    useEffect(() => {
        handleObtenerAlmacenesExhibidoresList();
        handleChangeTitle("Catálogo de Almacenes Exhibidores");
        handleChangeClavePaginaActual("Almacenes Exhibidores");
        // eslint-disable-next-line
    }, []);

    // Modo nuevo = no hay ningún registro seleccionado de la lista
    const esModoNuevo = !almacenesExhibidoresSeleccionado?.AlmacenExhibidor ||
        almacenesExhibidoresSeleccionado.AlmacenExhibidor.trim() === "";

    const columns = [
        { title: "Almacén Exhibidor", field: "AlmacenExhibidor", width: 300 },
        { title: "Status", field: "Status", width: 150 },
    ];

    return (
        <Fragment>
            <SizeSoftXLayout
                titlePage="Catálogo de Almacenes Exhibidores"
                buttonActions={<MnuAlmacenesExhibidoresActions />}
            >
                <Box>
                    {/* Campo de captura: habilitado solo en modo Nuevo */}
                    <Box sx={{ mb: 2, p: 2, border: "1px solid #ddd", borderRadius: 2, bgcolor: "#f9f9f9" }}>
                        <TextField autoComplete="off"
                            label="Descripción de Almacén Exhibidor"
                            name="AlmacenExhibidor"
                            value={almacenesExhibidoresPayLoad?.AlmacenExhibidor?.value ?? ""}
                            onChange={handleChangeDataAlmacenesExhibidoresPayload}
                            disabled={statusEnableFields || !esModoNuevo}
                            fullWidth
                            size="small"
                            inputProps={{ maxLength: 100 }}
                            error={almacenesExhibidoresPayLoad?.AlmacenExhibidor?.error ?? false}
                            helperText={almacenesExhibidoresPayLoad?.AlmacenExhibidor?.helper ?? ""}
                        />
                    </Box>

                    {/* Lista de almacenes exhibidores */}
                    <Card sx={{ mb: 2 }}>
                        <CardContent>
                            <Divider sx={{ mb: 2 }} />
                            <SizeSoftXTableCatalogos
                                columns={columns}
                                data={listaAlmacenesExhibidores}
                                id="AlmacenExhibidor"
                                row={almacenesExhibidoresSeleccionado}
                                setRow={handleAlmacenesExhibidoresSeleccionadoFromModal}
                                fontSize="small"
                            />
                        </CardContent>
                    </Card>
                </Box>
            </SizeSoftXLayout>

            <SizeSoftXModal
                open={statusOpenModalEliminarAlmacenesExhibidores}
                title={"¿Está seguro de querer eliminar el almacén exhibidor? Esta acción no se puede deshacer."}
                onClose={() => setStatusOpenModalEliminarAlmacenesExhibidores(false)}
                onSuccess={handleClickEliminarAlmacenesExhibidores}
                success="Eliminar"
            />
        </Fragment>
    );
}